export default __webpack_public_path__ + "static/media/IMG_5320.333b26df.JPG";